"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var subscription_1 = require("../../../api/subscription");
/*import ChangeTierForm from './ChangeTierForm';*/
var ChangeTierButton = function (props) {
    var className = props.className, id = props.id;
    var _a = react_1.useState({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = react_1.useState(0), companyId = _b[0], setCompanyId = _b[1];
    var _c = react_1.useState({ id: 0, name: "", companyId: "", scale: "", tier: "" }), supportData = _c[0], setSupportData = _c[1];
    var _d = react_1.useState([]), supportTierOptions = _d[0], setSupportTierOptions = _d[1];
    var _e = react_1.useState(false), modal = _e[0], setModal = _e[1];
    var toggle = function () { return setModal(!modal); };
    var submitUpdateSupport = function () {
        var obj = {
            supportId: supportData.id,
            tier: supportData.tier,
            userId: graphData,
        };
        subscription_1.changeTier(props.id, obj).then(function (response) {
            props.supportModalCallback(obj);
        });
        toggle();
    };
    var onLoad = function () {
        var id = 1;
        if (props.id) {
            setCompanyId(props.id);
        }
        if (supportData.id == 0)
            setSupportData(props.list.reduce(function (acc, item) { if (props.id == item.id)
                acc = item; return acc; }, { id: 0 }));
        //fetchSupports().then((response: any) => {
        //    setSupportTierOptions(response.list.map((item: any) => {
        //        var newItem: KeyValueLabel = {
        //            key: item.support.name,
        //            value: item.support.supportId,
        //            label: item.support.name
        //        };
        //        return newItem;
        //    }));
        //}).catch(console.error);
        setGraphData(props.userId);
    };
    var setFormChange = function (e, field) {
        var newSupportData = supportData;
        newSupportData[field] = e.target.value;
        console.log(newSupportData[field]);
        setSupportData(__assign({}, newSupportData));
        console.log(supportData);
    };
    react_1.useEffect(function () {
        onLoad();
    }, [supportData, setSupportData]);
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: toggle },
            React.createElement("a", { className: "padding-default" }, "Change Tier")),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Change Tier"),
            React.createElement(reactstrap_1.ModalBody, { id: "change-tier" },
                React.createElement(reactstrap_1.Form, null,
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { md: 12 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Tier" }, "Tier*"),
                                React.createElement(reactstrap_1.Input, { type: "select", name: "tier", id: "tier", placeholder: "Change Tier", value: supportData.tier, onChange: function (e) { return setFormChange(e, 'tier'); } },
                                    React.createElement("option", { value: "Basic" }, "Basic"),
                                    React.createElement("option", { value: "Standard" }, "Standard"),
                                    React.createElement("option", { value: "Premium" }, "Premium"))))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return submitUpdateSupport(); } }, "Confirm")))));
};
exports.default = ChangeTierButton;
//# sourceMappingURL=ChangeTierButton.js.map